import React, { useState, useEffect } from 'react';
import { Container, FormGroup, Button } from 'reactstrap'
import classNames from 'classnames';
import _ from 'lodash';

import Loader from "~/components/loader";

import User   from "~/services/user";


const AvatarSelector = ({selected, setPicture})=> {

  const [loading, setLoading] = useState(true);
  const [focused, setFocused] = useState();
  const [avatars, setAvatars] = useState([]);

  useEffect(()=> {
    setFocused(selected);
  }, [selected]);

  useEffect(()=> {
    (async()=> {
      setAvatars(_.chunk(await User.avatars(), 3));
      setLoading(false);
    })();
  }, []);

  const changeAvatar = async ()=> {
    setPicture(await User.setAvatar(focused));
  };

  return (
    <Container>
      <div className="avatar-selector">
        <h5 className="title"> Select your favorite avatar from the collection below </h5>

        { !avatars.length && loading && <Loader type={19} size={100} center />  }
        { avatars.map((chunk, index)=> (
          <div className="list" key={index}>
            { chunk.map((icon)=> (
              <div key={icon} className={classNames("item-box", {selected: focused == icon })} onClick={()=> setFocused(icon) }>
                <img src={icon} />
              </div>
            )) }
          </div>
        ))}

        <FormGroup>
          <Button color="primary" block className="m-t-30 mb-30" onClick={changeAvatar}> Select Avatar </Button>
        </FormGroup>
      </div>
    </Container>
  );
};

export default AvatarSelector;
